export default __webpack_public_path__ + "static/media/EC.a19e6221.svg";